import type { NavMainProps } from './main/nav/types';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const navData = (t: (key: string) => string): NavMainProps['data'] => [
  { title: t('main.home'), path: '/', icon: <Iconify width={22} icon="solar:home-angle-bold-duotone" /> },
  {
    title: t('main.components'),
    path: paths.components,
    icon: <Iconify width={22} icon="solar:atom-bold-duotone" />,
  },
  {
    title: t('main.pages'),
    path: '/pages',
    icon: <Iconify width={22} icon="solar:file-bold-duotone" />,
    children: [
      {
        subheader: t('main.other'),
        items: [
          { title: t('main.aboutUs'), path: paths.about },
          { title: t('main.contactUs'), path: paths.contact },
          { title: t('main.faqs'), path: paths.faqs },
          { title: t('main.pricing'), path: paths.pricing },
          { title: t('main.payment'), path: paths.payment },
          { title: t('main.maintenance'), path: paths.maintenance },
          { title: t('main.comingSoon'), path: paths.comingSoon },
        ],
      },
      {
        subheader: t('main.authDemo'),
        items: [
          { title: t('main.signIn'), path: paths.authDemo.split.signIn },
          { title: t('main.signUp'), path: paths.authDemo.split.signUp },
          { title: t('main.resetPassword'), path: paths.authDemo.split.resetPassword },
          { title: t('main.updatePassword'), path: paths.authDemo.split.updatePassword },
          { title: t('main.verify'), path: paths.authDemo.split.verify },
          { title: t('main.signInCentered'), path: paths.authDemo.centered.signIn },
          { title: t('main.signUpCentered'), path: paths.authDemo.centered.signUp },
          { title: t('main.resetPasswordCentered'), path: paths.authDemo.centered.resetPassword },
          { title: t('main.updatePasswordCentered'), path: paths.authDemo.centered.updatePassword },
          { title: t('main.verifyCentered'), path: paths.authDemo.centered.verify },
        ],
      },
      {
        subheader: t('main.error'),
        items: [
          { title: t('main.page403'), path: paths.page403 },
          { title: t('main.page404'), path: paths.page404 },
          { title: t('main.page500'), path: paths.page500 },
        ],
      },
      { subheader: t('main.dashboard'), items: [{ title: t('main.dashboard'), path: CONFIG.auth.redirectPath }] },
    ],
  },
  {
    title: t('main.docs'),
    icon: <Iconify width={22} icon="solar:notebook-bold-duotone" />,
    path: paths.docs,
  },
];
